export default __webpack_public_path__ + "static/media/arena_14.a3242a8d.jpeg";